import { createFileRoute } from '@tanstack/react-router'
import { DocumentDetailPage } from '@/pages/document-detail/document-detail-page'

export const Route = createFileRoute('/document/$id')({
  component: DocumentRoute,
})

function DocumentRoute() {
  const { id } = Route.useParams()

  return <DocumentDetailPage id={id} />
}
